import ContentMarkdown from '@/components/modules/ContentOne/ContentMarkdown'
import clsx from 'clsx'
import React from 'react'

const SectionContent: React.FC<{ locale: string, content: string, classes: string }> = ({ locale, content, classes }) => {
    return (
        <div className={clsx(classes)}>
            <ContentMarkdown locale={locale} content={content} />
        </div>
    )
}

export default SectionContent